// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a63f537b","461":"a59feb40"}[chunkId] + ".chunk.js";
};